module.exports = __webpack_public_path__ + "static/hero-cans-es-MX-593f0ecc77b3d628241cf844baa9a402.png";